export const paths = ['/purchase-order'];
